const OverdueNoFollowed = () => import(/* webpackChunkName: "UnassignedStore" */ '@/views/OverdueNoFollowed')
const OverdueNoFollowedSearch = () => import(/* webpackChunkName: "OverdueNoFollowedSearch" */ '@/views/Search/overdueNoFollowedSearch')
const overdueNoFollowedRouter = [
  {
    path: '/overdueNoFollowed',
    component: OverdueNoFollowed,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Overdue Not Followed'
    }
  },
  {
    path: '/overdueNoFollowed/search',
    component: OverdueNoFollowedSearch,
    meta: { // 给路由对象添加额外的信息
      scrollY: 0,
      title: 'Overdue Not Followed Search'
    }
  }
]

export default overdueNoFollowedRouter
